import { observer } from 'mobx-react';
import * as React from 'react';

import './group.scss';

interface FieldGroupProps {
    children: React.ReactNode;
    contrast?: boolean;
    className?: string;
}

export const FieldGroup = observer(function FieldGroup(props: FieldGroupProps) {
    const { className, contrast, children } = props;

    return (
        <fieldset
            className={classnames(className, 'field-group', {
                'field-group--contrast': contrast
            })}
        >
            {children}
        </fieldset>
    );
});
